(function() { window.GUID_5be6599b_ec97_4804_95f1_13c9a20e1f71 = { getGuid: function() { return "5be6599b-ec97-4804-95f1-13c9a20e1f71"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class RatingPopup extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            constructor(controlId) {
                super(controlId);
                this.controlId = controlId;
            }
            OnControlInstantiation(params) { }
            OnBindEvents() { }
            OnDispose() { }
        }
        Controls.RatingPopup = RatingPopup;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=RatingPopup.js.map
